// spellchecker:ignore jssdk, xfbml

//#region Imports
import once from "lodash/once";
import { SETTINGS_FACEBOOK_APP_ID } from "@anydo/core";

declare global {
  interface Window {
    fbAsyncInit: () => void;
  }
}

declare var FB: IFacebook;
//#endregion

//#region Types
interface IFacebookPermissions {
  scope: string;
  return_scopes?: boolean;
}

type FacebookUiArgsT = {
  method: "send";
  link: string;
  to?: string;
  display?: "popup" | "dialog" | "iframe" | "touch" | "async" | "hidden" | "none";
};

interface IFacebook {
  init(_: any): void;
  login(cb: (response: any) => boolean, permissions: IFacebookPermissions): void;
  getLoginStatus(cb: (_: { status: string; authResponse: any }) => void): void;
  ui(_: FacebookUiArgsT): void;
}
//#endregion

export const loadFacebook = once(loadFacebookOnce);

function loadFacebookOnce(): Promise<IFacebook> {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.id = "facebook-jssdk";
    script.async = true;
    script.onerror = reject;

    window.fbAsyncInit = function fbAsyncInit() {
      FB.init({
        appId: SETTINGS_FACEBOOK_APP_ID,
        xfbml: true,
        version: "v2.7",
      });
      resolve(FB);
    };

    if (document.head) {
      document.head.appendChild(script);
    } else {
      throw new TypeError("loadFacebook(): document.head isn't declared");
    }
  });
}
